import {
    configureStore,
    Store
} from '@reduxjs/toolkit';


import {SubscriptionsReducer} from "../features/billing-management/subscriptions/reducers";
import {UserProfileAttributesReducer} from "../features/users-management/user-profile-attributes/reducers";
import {OrganizationsReducer} from "../features/accounts-management/organizations/reducers";

import {AccountsReducer} from "../features/accounts-management/accounts/reducers";
import {AccountApplicationsReducer} from "../features/accounts-management/account-applications/reducers";
import {ApplicationsReducer} from "../features/accounts-management/applications/reducers";

const reducers = {
    userProfileAttributes: UserProfileAttributesReducer,
    subscriptions: SubscriptionsReducer,
    organizations: OrganizationsReducer,
    accounts: AccountsReducer,
    accountApplications: AccountApplicationsReducer,
    applications: ApplicationsReducer
};

// function sortObj(obj: { [key: string]: string }) {
//     return Object.keys(obj)
//                  .sort()
//                  .reduce(function (result: { [key: string]: any }, key) {
//                      result[key] = obj[key];
//                      return result;
//                  }, {});
// }
//
// const sorted = sortObj(reducers);


// added this middleware  to disable this error - A non-serializable value was detected in the state, in the path...
// @todo disable if better way is found
export const store: Store = configureStore({
                                               reducer: reducers,
                                               middleware: (getDefaultMiddleware) =>
                                                   getDefaultMiddleware({
                                                                            serializableCheck: false,
                                                                        }),
                                           });


// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
